module.exports = __webpack_public_path__ + "img/antes_despues_49.2e545984.png";